import React, { Component } from "react";
import firebase from "../Firebase";
import { Link } from "react-router-dom";
import home from "../assets/home.png";

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: "",
      projname: "",
      description: "",
      status: "",
      deployment: "",
    };
  }

  componentDidMount() {
    const ref = firebase
      .firestore()
      .collection("tracker")
      .doc(this.props.match.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        const app = doc.data();
        this.setState({
          key: doc.id,
          projname: app.projname,
          description: app.description,
          status: app.status,
          deployment: app.deployment,
        });
      } else {
        console.log("No such a document!");
      }
    });
  }

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ app: state });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const { projname, description, status, deployment } = this.state;

    const updateRef = firebase
      .firestore()
      .collection("tracker")
      .doc(this.state.key);
    updateRef
      .set({
        projname,
        description,
        status,
        deployment,
      })
      .then((docRef) => {
        this.setState({
          key: "",
          projname: "",
          description: "",
          status: "",
          deployment: "",
        });
        // this.props.history.push("/show/" + this.props.match.params.id);
        this.props.history.push("/");
      })
      .catch((error) => {
        console.error("Error while adding a document: ", error);
      });
  };

  render() {
    return (
      <div className="container" style={{ backgroundColor: "#ffffff" }}>
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title mt-4">Edit App Details</h3>
          </div>
          <div className="panel-body">
            <h4>
              <Link to="/">
                <img src={home} alt="home icon" style={{ width: "50px" }} />
              </Link>
            </h4>
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label htmlFor="Project Name">Project Name:</label>
                <input
                  type="text"
                  className="form-control"
                  name="projname"
                  value={this.state.projname}
                  onChange={this.onChange}
                  placeholder="Project Name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="description">Description:</label>
                <input
                  type="text"
                  className="form-control"
                  name="description"
                  value={this.state.description}
                  onChange={this.onChange}
                  placeholder="Description"
                />
              </div>
              <div className="form-group">
                <label htmlFor="status">Dev. Status:</label>
                <input
                  type="text"
                  className="form-control"
                  name="status"
                  value={this.state.status}
                  onChange={this.onChange}
                  placeholder="Status"
                />
              </div>
              <div className="form-group">
                <label htmlFor="deployment">Deployment status:</label>
                <input
                  type="text"
                  className="form-control"
                  name="deployment"
                  value={this.state.deployment}
                  onChange={this.onChange}
                  placeholder="Deployment status"
                />
              </div>
              <button type="submit" className="btn btn-success">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Edit;
